import { Stack, Text, TextInput } from "@mantine/core";
import { ReactElement } from "react";
import { useStyles } from "./DNSAliasInput.styled";
import { IDNSAliasInputProps } from "./types";
import { useFormContext } from "react-hook-form";
import ErrorMessage from "@common/components/text/ErrorMessage";
import { MIN_DNS_ALIAS_LENGTH } from "./constants";

export default function DNSAliasInput({
  id = "dns_alias",
  placeholder,
  disabled,
  required,
  defaultValue,
  isNew,
  availabilityError,
}: IDNSAliasInputProps): ReactElement {
  const { classes } = useStyles({ disabled });

  const {
    register,
    formState: { errors },
  } = useFormContext();

  // FIX
  // issue when casting: https://github.com/react-hook-form/react-hook-form/issues/9185
  const error =
    typeof errors?.[id]?.message === "string"
      ? String(errors[id]?.message)
      : availabilityError?.message || availabilityError?.status;

  return (
    <Stack spacing="xs">
      <div className={classes.wrapper}>
        <TextInput
          id={id}
          className={classes.input}
          placeholder={placeholder || "Update DNS alias"}
          disabled={disabled}
          defaultValue={defaultValue}
          {...register(id, {
            disabled,
            required,
            shouldUnregister: true,

            minLength: {
              value: MIN_DNS_ALIAS_LENGTH,
              message: "DNS alias must be at least 3 characters.",
            },
            pattern: {
              value: RegExp(process.env.DNS_ALIAS_PATTERN),
              message: "Please use letters, numbers and dashes only.",
            },
            validate: {
              // FIX: minLength allows for length === 0
              length(value) {
                return (
                  value.length > 0 || "DNS alias must be at least 3 characters."
                );
              },
              newName(value) {
                return isNew || value !== defaultValue;
              },
              reservedName(value: string): boolean | string {
                return (
                  !process.env.DNS_ALIAS_DENY_LIST.includes(value as string) ||
                  "Invalid DNS alias, please use another."
                );
              },
            },
          })}
        />

        <Text className={classes.label} span>
          .metabaseapp.com
        </Text>
      </div>

      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Stack>
  );
}
